










import { Component, Vue } from 'vue-property-decorator';
import ActivityCard from '@/components/common/ActivityCard.vue';

@Component({
  components: {
    ActivityCard,
  },
})
export default class ActivityTab extends Vue {
  private activityList = [
    {
      activityId: 1,
      accountName: 'セオリー太郎',
      accountIconUrl: 'test.jpeg',
      activityTitle: '課題を追加しました。',
      activityMessage:
        'THEORY-28 Gitとのデータ連携テストを行う。Gitとのデータ連携のテストを行う。テスト実装を行い、セオリーで必要なGit機能を満たすための連携実験を機能毎（例：API毎）に行う。',
      createdAt: '2020-06-15 13:12',
    },
    {
      activityId: 2,
      accountName: 'セオリー太郎',
      accountIconUrl: 'test.jpeg',
      activityTitle: '課題を追加しました。',
      activityMessage:
        'THEORY-28 Gitとのデータ連携テストを行う。Gitとのデータ連携のテストを行う。テスト実装を行い、セオリーで必要なGit機能を満たすための連携実験を機能毎（例：API毎）に行う。',
      createdAt: '2020-06-15 13:12',
    },
    {
      activityId: 3,
      accountName: 'セオリー太郎',
      accountIconUrl: 'test.jpeg',
      activityTitle: '課題を追加しました。',
      activityMessage:
        'THEORY-28 Gitとのデータ連携テストを行う。Gitとのデータ連携のテストを行う。テスト実装を行い、セオリーで必要なGit機能を満たすための連携実験を機能毎（例：API毎）に行う。',
      createdAt: '2020-06-15 13:12',
    },
    {
      activityId: 4,
      accountName: 'セオリー太郎',
      accountIconUrl: 'test.jpeg',
      activityTitle: '課題を追加しました。',
      activityMessage:
        'THEORY-28 Gitとのデータ連携テストを行う。Gitとのデータ連携のテストを行う。テスト実装を行い、セオリーで必要なGit機能を満たすための連携実験を機能毎（例：API毎）に行う。',
      createdAt: '2020-06-15 13:12',
    },
    {
      activityId: 5,
      accountName: 'セオリー太郎',
      accountIconUrl: 'test.jpeg',
      activityTitle: '課題を追加しました。',
      activityMessage:
        'THEORY-28 Gitとのデータ連携テストを行う。Gitとのデータ連携のテストを行う。テスト実装を行い、セオリーで必要なGit機能を満たすための連携実験を機能毎（例：API毎）に行う。',
      createdAt: '2020-06-15 13:12',
    },
  ];
}
